import React from 'react'
import { IconShell } from '@myxplor/icons'

const NewWindowIcon = props => (
  <IconShell {...props} title="Link will open in a new window">
    <g>
      <path
        fill="none"
        stroke="currentColor"
        vectorEffect="non-scaling-stroke"
        d="M 40 20 L 80 20 L 80 60"
      />
      <path
        fill="none"
        stroke="currentColor"
        vectorEffect="non-scaling-stroke"
        d="M 40 60 L 80 20"
      />
    </g>
  </IconShell>
)

export default NewWindowIcon



// WEBPACK FOOTER //
// ./src/ui/gov-messages/views/new-window-icon.jsx